module.exports = __webpack_public_path__ + "img/worksbot_img19122403.e6fc2219.jpg";